import { FileUploadSchemeDefinition } from "./file-upload-types";
import { BackgroundColor } from "../../background/constants/background-types";

import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createFileUploadMapDefinition } from "../../../utils/scheme-helper";

function createSchemes() {
  let newSchemes: AllColors.FileUploadSchemeConfiguration<FileUploadSchemeDefinition> = {};

  AllColors.FILE_UPLOAD_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      dropzoneBorderSingle: AllColors[`COLOR_${toConstantCase(element.schemeName)}_20`],
      dropzoneBackground: AllColors[`COLOR_${toConstantCase(element.schemeName)}_OPACITY_20`],
      dropzoneHoverBackground: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      dropzoneHoverBorder: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dropzoneOnDragHoverBackground: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      dropzoneOnDragHoverBorder: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      errorMessageColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_2`],
      dragOverBorder: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      dropzoneIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dropzoneContentColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      dropzoneLinkColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dropzoneDragOverBackground: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      dropzoneDragOverBorder: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      uploadCompleteContentColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      uploadCompleteBackground: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      successProgressIconColor: AllColors[`COLOR_GREY900`],
      successProgressTextColor: AllColors[`COLOR_SYSTEM_SUCCESS_DARK`],
      errorProgressIconColor: AllColors[`COLOR_GREY900`],
      errorProgressTextColor: AllColors[`COLOR_GREY900`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const FILE_UPLOAD_SCHEME_CONFIG: AllColors.FileUploadSchemeConfiguration<FileUploadSchemeDefinition> = createSchemes();

export const FILE_UPLOAD_SCHEME_MAP: Map<BackgroundColor | "default", FileUploadSchemeDefinition> = new Map(
  Object.entries(createFileUploadMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    FILE_UPLOAD_SCHEME_CONFIG[config as string]
  ])
);
